import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { useCreateEmployee } from '@/api/queries/employee.queries';
import { PageHeader } from '@/components/shared/PageHeader';
import { EmployeeForm } from '@/components/employees/EmployeeForm';

export default function AddEmployeePage() {
  const navigate = useNavigate();
  const createEmployee = useCreateEmployee();
  const [serverError, setServerError] = useState('');

  const handleSubmit = async (payload) => {
    setServerError('');
    try {
      const result = await createEmployee.mutateAsync(payload);
      if (result?.warnings?.length) {
        result.warnings.forEach(w => toast.warning(w.message));
      }
      const newId = result?.data?.id;
      navigate(newId ? `/employees/${newId}` : '/employees');
    } catch (err) {
      setServerError(err?.response?.data?.error?.message || 'Failed to create employee. Is employee-service running?');
    }
  };

  return (
    <div className="max-w-5xl space-y-5 fade-in">
      <PageHeader
        title="Add Employee"
        breadcrumb={[{ label: 'Employees', href: '/employees' }, { label: 'Add Employee' }]}
        actions={
          <button onClick={() => navigate('/employees')}
            className="flex items-center gap-1.5 text-[13px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">
            <ArrowLeft size={15}/> Back
          </button>
        }
      />
      <EmployeeForm onSubmit={handleSubmit} submitting={createEmployee.isPending} serverError={serverError}/>
    </div>
  );
}
